export default "__VITE_ASSET__CmH2SfHL__"